// extracted by mini-css-extract-plugin
module.exports = {"gg_menu_btn":"gg_menu_btn--GgMenuButton-components__1-3sr","ggMenuBtn":"gg_menu_btn--GgMenuButton-components__1-3sr"};